import { render, staticRenderFns } from "./MimecastMailService.vue?vue&type=template&id=00f31ddc&"
import script from "./MimecastMailService.vue?vue&type=script&lang=js&"
export * from "./MimecastMailService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports